import request from '@/utils/request'

//库存初始化


//查询库存初始化列表
export function getKccshList(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/cskc/list",
        data: data
    })
}

//获取化学品信息
export function getHxpCascader() {
    return request({
        method: 'get',
        url: "/yzdservice/api/enterprise/credentials/common/getHxpCascader"
    })
}
//新增/编辑保存库存初始化数据（暂时保存）
export function addOrUpdSaveTemp(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/cskc/addOrUpdSaveTemp",
    data: data
  })
}

//新增/编辑保存库存初始化数据（提交入库）
export function addOrUpdSave(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/cskc/addOrUpdSave",
        data: data
    })
}

//选择仓库信息
export function getCkxxByCskc() {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/dwCk/getCkxxByCskc"
    })
}

//获取库存初始化详情
export function detail(data) {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/dwCk/cskc/detail/" + data
    })
}

//删除库存初始化数据
export function remove(data) {
    return request({
        method: 'delete',
        url: "/yzdservice/enterprise/dwCk/cskc/remove/" + data
    })
}


export function userInfo() {
    return request({
        method: 'get',
        url: "/organization/api/user/userInfo"
    })

}

//导出
export function excelwriter(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwCk/cskc/excelwriter",
        data: data,
        responseType: 'blob'
    })
}
//库存初始化完毕
export function finishKcCsh() {
    return request({
        method: 'put',
        url: '/yzdservice/enterprise/dwCk/cskc/finish'
    })
}
//根据化学品获取单位下拉
export function getDwByHxp(id) {
    return request({
        method: 'get',
        url: '/yzdservice/common/hxpDw/'+id
    })
}
//判断单位是否是仓储单位
export function pdSfCcqy() {
    return request({
        method: 'get',
        url: '/yzdservice/enterprise/yzddw/pdSfCcqy'
    })
}
